var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.86194 7.86212C2.98696 7.73713 3.1565 7.66692 3.33327 7.66692C3.51005 7.66692 3.67959 7.73713 3.80461 7.86212L6.65461 10.7121L12.8499 4.20745C12.9718 4.07926 13.1395 4.00472 13.3163 4.00022C13.4931 3.99572 13.6644 4.06163 13.7926 4.18345C13.9208 4.30527 13.9953 4.47303 13.9998 4.64981C14.0043 4.8266 13.9384 4.99793 13.8166 5.12612L7.14994 12.1261C7.08858 12.1907 7.0149 12.2423 6.93326 12.2779C6.85162 12.3135 6.76367 12.3324 6.67461 12.3334H6.66661C6.48981 12.3334 6.32027 12.2631 6.19527 12.1381L2.86194 8.80478C2.73696 8.67976 2.66675 8.51022 2.66675 8.33345C2.66675 8.15667 2.73696 7.98713 2.86194 7.86212Z",
    fill: "#1EC198"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.60c25a17feec00baa8872983b2cc48f6.svg";
export { ForwardRef as ReactComponent };